import * as React from 'react';
import { cn } from '@/lib/utils';
import { Label } from '@/components/ui/label';
import { Switch } from '@/components/ui/switch';

const FormSwitchWrapper = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn(
      'c-form-switch-wrapper',
      // styles
      'space-y-1',
      className
    )}
    {...props}
  />
));
FormSwitchWrapper.displayName = 'FormSwitchWrapper';

const FormSwitch = React.forwardRef(({ className, label, id, ...props }, ref) => {
  const compId = React.useId();

  return (
    <div className={cn('flex items-center gap-2', className)}>
      <Switch
        id={id ?? compId}
        ref={ref}
        {...props}
      />
      {label && (
        <Label
          htmlFor={id ?? compId}
          className="font-light text-primary-dark"
        >
          {label}
        </Label>
      )}
    </div>
  );
});
FormSwitch.displayName = 'FormSwitch';

export { FormSwitch, FormSwitchWrapper };
